import React from "react"
import FormGroup from "../../../Form/FormGroup"
import Textarea from "../../../Form/Textarea"

const AiConditional = ({ data = {}, onChange = () => { } }) => {
    const handleChangeContent = (name, value) => {
        onChange(name, value)
    }

    return (
        <FormGroup>
            <FormGroup labelText="O que a IA deve analisar?">
                <Textarea
                    placeholder="Descreva claramente o que a IA deve verificar com base na conversa. Ex: O lead demonstrou interesse em agendar uma reunião?"
                    onChange={(e) => handleChangeContent("analysis_instruction", e.target.value)}
                    value={data?.analysis_instruction || ""}
                    rows={5}
                />
            </FormGroup>
            <FormGroup labelText='Quando a resposta deve ser considerada "Verdadeira"?'>
                <Textarea
                    placeholder="Ex: O lead usou palavras como 'quero', 'sim', 'gostaria de agendar'."
                    onChange={(e) => handleChangeContent("condition_true", e.target.value)}
                    value={data?.condition_true || ""}
                    rows={4}
                />
            </FormGroup>
            <FormGroup labelText='Quando a resposta deve ser considerada "Falsa"?'>
                <Textarea
                    placeholder="Ex: O lead disse que 'não está interessado' ou 'vai pensar depois'."
                    onChange={(e) => handleChangeContent("condition_false", e.target.value)}
                    value={data?.condition_false || ""}
                    rows={4}
                />
            </FormGroup>
        </FormGroup>
    )
}

export default AiConditional